import { Button, Flex } from '@chakra-ui/react';
import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { BorderRadiusPopover, BorderWidthPopover } from 'modules/common/components/Border';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { SignatureWidgetData } from './SignatureWidget.types';

export const SignatureWidgetToolbarMenu = ({ onClick }: { onClick: () => void }) => {
  return (
    <Flex mr='8px' gap='8px' align='center'>
      <AddSignature onClick={onClick} />
      <ToolbarDivider />
      <BackgroundColorOption />
      <BorderColorOption />
      <BorderWidthOption />
      <BorderRadiusOption />
    </Flex>
  );
};

const AddSignature = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'signatureToolbar' });

  return (
    <Button
      size='sm'
      onClick={onClick}
      fontWeight='semibold'
      variant='ghost-with-active'
      data-testid='alttext-toolbar-button'
    >
      {t('addSignature')}
    </Button>
  );
};

const BackgroundColorOption = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'signatureToolbar' });
  const { backgroundColor, updateWidget } = useWidget<SignatureWidgetData>();

  const onUpdateBackgroundColor = (color: string) => updateWidget({ backgroundColor: color });

  return (
    <ColorPicker
      color={backgroundColor}
      label={t('backgroundColor')}
      onChange={onUpdateBackgroundColor}
      showNoColorOption={false}
      showNoColorChecker
    />
  );
};

const BorderColorOption = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'signatureToolbar' });
  const { borderColor, updateWidget } = useWidget<SignatureWidgetData>();

  const onUpdateBorderColor = (borderColor: string): void => updateWidget({ borderColor });

  return (
    <ColorPicker color={borderColor} onChange={onUpdateBorderColor} label={t('borderColor')} iconStyle={'border'} />
  );
};

const BorderWidthOption = () => {
  const { borderWidth, updateWidget } = useWidget<SignatureWidgetData>();

  const onUpdateBorderWidth = (width: number): void => updateWidget({ borderWidth: width });

  return <BorderWidthPopover value={borderWidth} onChange={onUpdateBorderWidth} />;
};

const BorderRadiusOption = () => {
  const { borderRadius, updateWidget } = useWidget<SignatureWidgetData>();

  const onUpdateBorderRadius = (borderRadius: number): void => updateWidget({ borderRadius });

  return <BorderRadiusPopover value={borderRadius} onChange={onUpdateBorderRadius} />;
};
